import React, { memo, useRef, useState, useEffect } from 'react';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import  * as TYPES  from '../../models/types';
import { backTo, isNormalZhEnCss, isMath, getClientRect, delay } from '../../utils';

import styles from './styles.module.scss';

import union from '../../assets/img/public/icons/union.svg';
import unionNewP from '../../assets/img/public/icons/unionNewP.svg';
import unionNewM from '../../assets/img/public/icons/unionNewM.svg';
import airplane from '../../assets/img/public/icons/airplane.svg';
import travel_logo from '../../assets/img/logos/travel_logo.svg';
import WeiBo from '../../assets/img/public/icons/WeiBo.svg';
import QQ from '../../assets/img/public/icons/QQ.svg';
import WeChat from '../../assets/img/public/icons/WeChat.svg';

const Index = memo((props) => {

  const dispatch = useDispatch();
  const { basicDrawerEvent, telModelDventShow } = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const {layouts, lang} = useSelector(({localesReducer}) => localesReducer.i18n);
  const { scrolVal, scrolFidx } = useSelector(({scrollNumReducer}) => scrollNumReducer);
  let navigate = useNavigate();

  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return isNormalZhEnCss(lang, 'English') ? styles.normalXl2En : styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return isNormalZhEnCss(lang, 'English') ? styles.normalXlEn : styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return isNormalZhEnCss(lang, 'English') ? styles.normalLgEn : styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return isNormalZhEnCss(lang, 'English') ? styles.normalMdEn : styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
    }
  };


  const transitionFed = 'all 1.8s';
  const opacityStart = 0;
  const opacityEnd = 1;
  const translateYStart = `translateY(${isMath(recReSizeReducer, 300)})`;
  const translateYEnd = `translateY(${isMath(recReSizeReducer, 0)})`;
  const translateYOtherEnd = `translateY(${isMath(recReSizeReducer, 50)})`;
  const translateScaleStart = `scale(1.5)`;
  const translateScaleEnd = `scale(1)`;

  // 背景透明度 start
  const initFedOpacityStart = {
    opacity: opacityStart,
    transition: transitionFed,
  };
  // 背景透明度 end


  // 位移加透明度 start
  const initFedStart = {
    opacity: opacityStart,
    transition: transitionFed,
    transform: translateYStart,
  };

  const initFedScaleStart = {
    opacity: opacityStart,
    transition: transitionFed,
    transform: translateScaleStart,
  };
  // 位移加透明度 end

  // TODO: threePage start
  const desktopMobileAnimatedFooterRef = useRef(null);
  const [desktopMobileAnimatedFooterStyle, setDesktopMobileAnimatedFooterStyleApi] = useState(initFedOpacityStart);

  const desktopMobileAnimatedFooteScroll = (curEle, num) => {
    let { isClientRect } = getClientRect(curEle, num); // 当前元素
      if (isClientRect) {
        setDesktopMobileAnimatedFooterStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          // transform: translateYStart,
        });
        
      }else{
        setDesktopMobileAnimatedFooterStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          // transform: translateYEnd,
        });
        
      }
  }

  const desktopMobileScroll = () => {
      if(recReSizeReducer > 750){
          // PC
          desktopMobileAnimatedFooteScroll(desktopMobileAnimatedFooterRef, 200);
      }else{
          // H5
          desktopMobileAnimatedFooteScroll(desktopMobileAnimatedFooterRef, 470);
      }
  }
  // TODO: threePage end

  useEffect(() => {
    desktopMobileScroll();
  }, [scrolVal]);

  
  const [stayConnectedFlag, setStayConnectedFlag] = useState(false);

  // 桌面
  const desktops = () => {
    const {navLinkList} = layouts.headerData;
    const {
      backToTitle,
      csh,
      websiteRecord,// 备案->中文
      copyright, // 版权->中文
      companyAddress, // 公司地址->中文
      tel,
    } = layouts.footerData;
    return (
        <>
          <div className="unionTop">
            <div className="innerBox">
              {/* <img className="unionIcon" src={union} alt=""/> */}
              <img className="unionIcon" src={unionNewP} alt=""/>
              <div className="backToTop" onClick={handleBackToTop} >
                <img className="airplaneIcon" src={airplane} alt=""/>
                <span data-langkey="FTNLTOP001">{backToTitle}</span>
              </div>
            </div>
          </div>
          <div className="unionBot">
            <div className="left">
              <div className="desc">
                <p><span data-langkey="FTCSH001">{csh}<a href={`tel:${tel}`}>{tel}</a></span></p>
                <p><span data-langkey="CADR001">{companyAddress}</span></p>
                <p><span data-langkey="WRICP001">{websiteRecord}</span></p>
              </div>
            </div>
            <div className="content">
              <div className="travelLogo" onClick={handleJump}><img src={travel_logo} alt="" /></div>
            </div>
            <div className="right">
              <div className="innerInfo">
                <div 
                  className="stayConnected"
                  style={{justifyContent: 'unset'}}
                  onMouseMove={handleHover}
                  onMouseLeave={handleHover}
                >
                  <div 
                    className='stayConnectedBox'
                    style={{
                      transform: `translateY(${!stayConnectedFlag ? -56 : 13}px)`,
                      transition: `all .5s ease 0s`,
                      cursor: 'pointer'
                    }}
                  >
                    <ul className="socialMedia" style={{marginBottom: 51}}>
                      <li><img src={WeiBo} alt="WeiBo" /></li>
                      <li><img src={QQ} alt="QQ" /></li>
                      <li><img src={WeChat} alt="WeChat" /></li>
                    </ul>
                    <div><span>STAY CONNECTED</span></div>
                  </div>
                </div>
                <div className="fNavLink">
                  <span onClick={() => handleNavLink(TYPES.CUSTOMIZEDTRAVEL)}>{navLinkList[0].title}</span>
                  <span onClick={() => handleNavLink(TYPES.FAQ)}>{navLinkList[1].title}</span>
                  <span onClick={() => handleNavLink(TYPES.BOOKINGINSTRUCTIONS)}>{navLinkList[2].title}</span>
                </div>
                <div className="rights"><span data-langkey="FTNLRR001">{copyright}</span></div>
              </div>
            </div>
          </div>
        </>
    );
  }

  const handleHover = (event) => {
    if(event.type === 'mousemove'){
      setStayConnectedFlag(true);
    }else{
      setStayConnectedFlag(false);
    }
  }


  // 移动端
  const mobiles = () => {
    const {navLinkList} = layouts.headerData;
    const {
      backToTitle,
      csh,
      websiteRecord,// 备案->中文
      copyright, // 版权->中文
      companyAddress, // 公司地址->中文
      tel,
    } = layouts.footerData;
    return (
        <>
          <div className="unionTop">
            <div className="innerBox">
              <img className="unionIcon" src={unionNewM} alt=""/>
              <div className="backToTop" onClick={handleBackToTop}>
                <img className="airplaneIcon" src={airplane} alt=""/>
                <span data-langkey="FTNLTOP001">{backToTitle}</span>
              </div>
            </div>
          </div>

          <div className="unionBot">
            <div className="left">
              <div className="travelLogo" onClick={handleJump}><img src={travel_logo} alt="" /></div>
            </div>
            <div className="content">
              <div 
                  className="stayConnected"
                  style={{justifyContent: 'unset'}}
                  onMouseMove={handleHover}
                  onMouseLeave={handleHover}
                >
                  <div 
                    className='stayConnectedBox'
                    style={{
                      transform: `translateY(${!stayConnectedFlag ? -56/100 : 24/100}rem)`,
                      transition: `all .5s ease 0s`,
                      cursor: 'pointer'
                    }}
                  >
                    <ul className="socialMedia" style={{marginBottom: `${48/100}rem`}}>
                      <li><img src={WeiBo} alt="WeiBo" /></li>
                      <li><img src={QQ} alt="QQ" /></li>
                      <li><img src={WeChat} alt="WeChat" /></li>
                    </ul>
                    <div className='socialDesc'><span>STAY CONNECTED</span></div>
                  </div>
                </div>
            </div>
            <div className="right">
              <div className="innerInfo">
                <div className="fNavLink">
                  <span onClick={() => handleNavLink(TYPES.CUSTOMIZEDTRAVEL)}>{navLinkList[0].title}</span>
                  <span onClick={() => handleNavLink(TYPES.FAQ)}>{navLinkList[1].title}</span>
                  <span onClick={() => handleNavLink(TYPES.BOOKINGINSTRUCTIONS)}>{navLinkList[2].title}</span>
                </div>
                <div className="desc">
                  <p><span data-langkey="FTCSH001">{csh}<a href={`tel:${tel}`}>{tel}</a></span></p>
                  <p><span data-langkey="CADR001">{companyAddress}</span></p>
                  <p><span data-langkey="WRICP001">{websiteRecord}</span></p>
                </div>
                <div className="rights"><span data-langkey="FTNLRR001">{copyright}</span></div>
              </div>
            </div>
          </div>
        </>
    );
  };


  // 判断是：桌面/移动端
  const isDesktopMobile = () => {
    return recReSizeReducer > 750 ? desktops() : mobiles();
  };

  const handleNavLink = (type) => {
    if(type === TYPES.CUSTOMIZEDTRAVEL){
      navigate('/customTravel');
      backTo();
    }else{
      dispatch(basicDrawerEvent({
        visible: TYPES.DRAWERSHOW,
        options: {
          type,
        },
      }));
    }
    
  }

  // 回到顶部
  let timer = null;
  const handleBackToTop = () => {
    /* cancelAnimationFrame(timer);
    timer = requestAnimationFrame(function fn() {
      document.body.style.transition = 'all 1s ease-in-out';
      let oTop = document.body.scrollTop || document.documentElement.scrollTop;
      if (oTop > 0) {
        window.scrollTo(0, oTop - 70);
        timer = requestAnimationFrame(fn);
      } else {
        cancelAnimationFrame(timer);
        document.body.style.transition = 'none';
      }
    }); */
    backTo();
  };

  const handleJump = () => {
    navigate('/');
    backTo();
  }


  return (
      <div 
        className={normal()} 
        ref={desktopMobileAnimatedFooterRef}
        style={{...props.config, ...desktopMobileAnimatedFooterStyle}}
      >
        {isDesktopMobile()}
      </div>
  );
});
export default Index;
